import React, { useEffect, useRef, useState } from "react";
import ClientCard from "./client-card.component";
import Marquee from "react-fast-marquee";
import CLIENT_DATA from "../../constant/client-data";

const ClientComponent = () => {
  const sourceDiv = useRef(null);
  const [marqueeTagWidth, setMarqueeTagWidth] = useState(0);

  useEffect(() => {
    if (sourceDiv.current) {
      const sourceDivData = sourceDiv.current.getBoundingClientRect();
      setMarqueeTagWidth(sourceDivData.width);
    }
  }, []);

  return (
    <div className="flex py-10 lg:py-20 w-full border-t border-t-[#a0a5e2] justify-center">
      <div
        className="flex w-full items-center justify-center pt-10 lg:pt-20"
        id="client-review"
      >
        <div
          className="max-w-7xl flex flex-col border rounded-lg lg:rounded-xl pt-5 lg:pt-20 pb-5
       border-[#a0a5e2] bg-white/0 backdrop-blur isolate px-2 lg:px-11 w-full"
        >
          <div className="relative flex w-full before:absolute before:h-28 before:top-1/4 before:w-full before:blur-3xl before:bg-[#433287] before:-z-10 after:absolute after:h-28 after:w-full after:blur-3xl after:bg-[#3d3464] after:-z-10 after:top-3/4">
            <div className="flex flex-col w-full gap-10 px-3 lg:px-0 lg:gap-20 lg:pt-4" ref={sourceDiv}>
              <h1
                className="text-2xl lg:text-4xl font-bold"
                data-aos="fade-up"
                data-aos-duration={1000}
                data-aos-delay={400}
              >
                Clients
              </h1>
              <div
                className="flex w-full"
                style={{
                  maxWidth: `${marqueeTagWidth}px`,
                }}
              >
                <Marquee>
                  {CLIENT_DATA &&
                    CLIENT_DATA.map((item, index) => (
                      <ClientCard index={index} props={item} />
                    ))}
                </Marquee>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ClientComponent;
